import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ServiceActions from '../redux/serviceRedux'
import MenuButton from '../components/MenuButton'
import LoginActions from '../redux/loginRedux'
import { withErrorBoundary } from '../errors/ErrorBoundary'

const styles = {
  root: {
    position: 'absolute',
    top: 0
  },
  appBar: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
    boxShadow: 'none'
  },
  flex: {
    flex: 1
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20 //
  }
}

class TopNav extends Component {
  render () {
    const { actions, classes } = this.props

    return (
      <div className={classes.root}>
             <MenuButton
              className={classes.menuButton}
              onClick={actions.serviceDrawerOpened}
            />
            <Typography className={classes.flex} type='title' color='inherit' />
       </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    loginDialogOpen: state.login.loginDialogOpen,
    authenticated: state.login.authenticated
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      loginDialogOpen: () => dispatch(LoginActions.loginDialogOpen()),
      loginDialogClose: () => dispatch(LoginActions.loginDialogClose()),
      loginDialogToggle: () => dispatch(LoginActions.loginDialogToggle()),
      serviceDrawerOpened: () => dispatch(ServiceActions.serviceDrawerOpened())
    }
  }
}

export default withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(TopNav)
))



// WEBPACK FOOTER //
// ./src/containers/TopNav.js